module.exports = __webpack_public_path__ + "static/media/MegurimB.7fe42883.png";